/**
 * Translations for Arabic and English UI text
 * Used for Secretary module and PDF exports
 */

export const translations = {
    en: {
        // Common
        patient: 'Patient',
        date: 'Date',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        print: 'Print',
        download: 'Download',
        view: 'View',

        // Secretary Module
        secretaryDashboard: 'Secretary Dashboard',
        appointments: 'Appointments',
        newAppointment: 'New Appointment',
        selectDate: 'Select Date',
        total: 'Total',
        done: 'Done',
        pending: 'Pending',
        scheduled: 'Scheduled',
        completed: 'Completed',
        cancelled: 'Cancelled',
        time: 'Time',
        reason: 'Reason',
        status: 'Status',
        selectPatient: 'Select Patient',
        appointmentDetails: 'Appointment Details',

        // Glasses
        glasses: 'Glasses',
        glassesPresc: 'Glasses Prescription',
        newGlasses: 'New Glasses',
        oldGlasses: 'Old Glasses',
        rightEye: 'Right Eye',
        leftEye: 'Left Eye',
        sphere: 'Sphere',
        cylinder: 'Cylinder',
        axis: 'Axis',
        addPower: 'Add Power',
        notes: 'Notes',

        // Medications
        medication: 'Medication',
        medications: 'Medications',
        dosage: 'Dosage',
        frequency: 'Frequency',
        duration: 'Duration',
        instructions: 'Instructions',
        beforeMeal: 'Before meal',
        afterMeal: 'After meal',
        withMeal: 'With meal',
        timesDaily: 'times daily',
        weeks: 'weeks',
        days: 'days',
        months: 'months',
        eyeDrops: 'Eye Drops',
        ointment: 'Ointment',
        tablets: 'Tablets',
        injection: 'Injection',

        // PDF
        opticalPrescription: 'OPTICAL PRESCRIPTION',
        medicationPrescription: 'MEDICATION PRESCRIPTION',
        validFor: 'This prescription is valid for 6 months from the date of issue.',
        followInstructions: 'Please follow the prescribed medication schedule.',

        // Treatments
        treatment: 'Treatment',
        treatments: 'Treatments',
        medicalTreatment: 'Medical Treatment',
        surgicalTreatment: 'Surgical Treatment',
        followupDate: 'Follow-up Date',
        treatmentPlan: 'Treatment Plan',

        // Investigations
        investigation: 'Investigation',
        investigations: 'Investigations',
        type: 'Type',
        details: 'Details',
        results: 'Results',
        recommendations: 'Recommendations',
        investigationReport: 'Investigation Report',

        // Labs
        lab: 'Lab',
        labs: 'Labs',
        panelType: 'Panel Type',
        purpose: 'Purpose',
        fitnessStatus: 'Fitness Status',
        fit: 'Fit',
        unfit: 'Unfit',
        labResults: 'Lab Results',

        // Surgery
        surgery: 'Surgery',
        surgeries: 'Surgeries',
        procedure: 'Procedure',
        eye: 'Eye',
        minor: 'Minor',
        major: 'Major',
        preOpDiagnosis: 'Pre-op Diagnosis',
        iolDetails: 'IOL Details',
        complications: 'Complications',
        postOpInstructions: 'Post-op Instructions',
        surgicalReport: 'Surgical Report',
    },

    ar: {
        // Common
        patient: 'المريض',
        date: 'التاريخ',
        save: 'حفظ',
        cancel: 'إلغاء',
        edit: 'تعديل',
        delete: 'حذف',
        print: 'طباعة',
        download: 'تحميل',
        view: 'عرض',

        // Secretary Module
        secretaryDashboard: 'لوحة السكرتارية',
        appointments: 'المواعيد',
        newAppointment: 'موعد جديد',
        selectDate: 'اختر التاريخ',
        total: 'الإجمالي',
        done: 'تم',
        pending: 'قيد الانتظار',
        scheduled: 'مجدول',
        completed: 'مكتمل',
        cancelled: 'ملغي',
        time: 'الوقت',
        reason: 'السبب',
        status: 'الحالة',
        selectPatient: 'اختر المريض',
        appointmentDetails: 'تفاصيل الموعد',

        // Glasses
        glasses: 'النظارات',
        glassesPresc: 'وصفة النظارة',
        newGlasses: 'نظارة جديدة',
        oldGlasses: 'نظارة قديمة',
        rightEye: 'العين اليمنى',
        leftEye: 'العين اليسرى',
        sphere: 'الكرة',
        cylinder: 'الأسطوانة',
        axis: 'المحور',
        addPower: 'قوة الإضافة',
        notes: 'ملاحظات',

        // Medications
        medication: 'الدواء',
        medications: 'الأدوية',
        dosage: 'الجرعة',
        frequency: 'التكرار',
        duration: 'المدة',
        instructions: 'التعليمات',
        beforeMeal: 'قبل الأكل',
        afterMeal: 'بعد الأكل',
        withMeal: 'مع الأكل',
        timesDaily: 'مرات يومياً',
        weeks: 'أسابيع',
        days: 'أيام',
        months: 'أشهر',
        eyeDrops: 'قطرة عين',
        ointment: 'مرهم',
        tablets: 'أقراص',
        injection: 'حقنة',

        // PDF
        opticalPrescription: 'وصفة النظارة الطبية',
        medicationPrescription: 'وصفة الأدوية',
        validFor: 'هذه الوصفة صالحة لمدة 6 أشهر من تاريخ الإصدار.',
        followInstructions: 'يرجى اتباع جدول الأدوية الموصوفة.',

        // Treatments
        treatment: 'العلاج',
        treatments: 'العلاجات',
        medicalTreatment: 'العلاج الدوائي',
        surgicalTreatment: 'العلاج الجراحي',
        followupDate: 'موعد المتابعة',
        treatmentPlan: 'خطة العلاج',

        // Investigations
        investigation: 'الفحص',
        investigations: 'الفحوصات',
        type: 'النوع',
        details: 'التفاصيل',
        results: 'النتائج',
        recommendations: 'التوصيات',
        investigationReport: 'تقرير الفحوصات',

        // Labs
        lab: 'تحليل',
        labs: 'التحاليل',
        panelType: 'نوع التحليل',
        purpose: 'الغرض',
        fitnessStatus: 'حالة اللياقة',
        fit: 'لائق',
        unfit: 'غير لائق',
        labResults: 'نتائج التحاليل',

        // Surgery
        surgery: 'عملية',
        surgeries: 'العمليات',
        procedure: 'الإجراء',
        eye: 'العين',
        minor: 'صغيرة',
        major: 'كبيرة',
        preOpDiagnosis: 'التشخيص قبل العملية',
        iolDetails: 'تفاصيل العدسة',
        complications: 'المضاعفات',
        postOpInstructions: 'تعليمات ما بعد العملية',
        surgicalReport: 'تقرير العملية',
    }
};

/**
 * Get translation function for a specific language
 * @param {string} lang - 'en' or 'ar'
 * @returns {function} - Function that returns translated text
 */
export const getTranslator = (lang = 'en') => {
    return (key) => translations[lang]?.[key] || translations.en[key] || key;
};

/**
 * Common Arabic medication instructions
 */
export const arabicMedicationInstructions = {
    'Once daily': 'مرة واحدة يومياً',
    'Twice daily': 'مرتين يومياً',
    'Three times daily': 'ثلاث مرات يومياً',
    'Four times daily': 'أربع مرات يومياً',
    'Every 4 hours': 'كل 4 ساعات',
    'Every 6 hours': 'كل 6 ساعات',
    'Every 8 hours': 'كل 8 ساعات',
    'Every 12 hours': 'كل 12 ساعات',
    'At bedtime': 'قبل النوم',
    'In the morning': 'في الصباح',
    'In the evening': 'في المساء',
    'As needed': 'عند الحاجة',
    'With food': 'مع الطعام',
    'Before food': 'قبل الطعام',
    'After food': 'بعد الطعام',
    'Apply to affected eye': 'يوضع على العين المصابة',
    'Apply to both eyes': 'يوضع على كلتا العينين',
    'Apply to right eye': 'يوضع على العين اليمنى',
    'Apply to left eye': 'يوضع على العين اليسرى',
    '1 drop': 'نقطة واحدة',
    '2 drops': 'نقطتان',
    'For 1 week': 'لمدة أسبوع واحد',
    'For 2 weeks': 'لمدة أسبوعين',
    'For 1 month': 'لمدة شهر واحد',
    'Continue until review': 'يستمر حتى المراجعة',
    'Stop if irritation occurs': 'يتوقف عند حدوث تهيج',
    'Shake well before use': 'يرج جيداً قبل الاستخدام',
    'Store in refrigerator': 'يحفظ في الثلاجة',
    'Keep away from children': 'يحفظ بعيداً عن الأطفال',
};

/**
 * Translate medication instruction to Arabic
 * @param {string} instruction - English instruction
 * @returns {string} - Arabic translation or original if not found
 */
export const translateMedicationInstruction = (instruction) => {
    if (!instruction) return '';

    // Check for exact match
    if (arabicMedicationInstructions[instruction]) {
        return arabicMedicationInstructions[instruction];
    }

    // Try to translate parts
    let translated = instruction;
    Object.keys(arabicMedicationInstructions).forEach(key => {
        if (instruction.includes(key)) {
            translated = translated.replace(key, arabicMedicationInstructions[key]);
        }
    });

    return translated;
};

export default translations;
